<template>
  <div class="filter-rate">
    <div class="filter-rate__headline">
      <UiText
        :text="`${data.title} (₴)`"
        tag="h3"
        font="promo-heading-3"
        bold
        color="typography-title01"
        align-center
      />
    </div>

    <div class="filter-rate__tabs">
      <UiBtn
        v-for="item in presetRates"
        :key="item.id"
        class="filter-rate__button"
        :text="item.title"
        :active="activeTab === item"
        color="default"
        size-small
        @click="activeTab = item"
      />
    </div>

    <SlideUpDown :active="isCustomValue">
      <div class="filter-rate-form">
        <NoUiSlider
          v-model="rangeValue"
          name="sum-rate"
          :min="presetRange.min"
          :max="presetRange.max"
          :step="1"
          :start="[ from, to ]"
          :half="[ presetRange.max / 5, 1 ]"
          class="filter-rate-form__slider"
        />

        <div class="filter-rate-form__inputs">
          <BaseInputMoney
            v-model="from"
            class="filter-rate-form__input"
            text-center
            maxlength="7"
            :max="presetRange.max"
            :error-messages="inputError"
          />

          <BaseInputMoney
            v-model="to"
            class="filter-rate-form__input"
            text-center
            maxlength="8"
            :max="presetRange.max"
            :error-messages="inputError"
          />
        </div>
      </div>
    </SlideUpDown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NoUiSlider from '@/components/Base/NoUiSlider'
import BaseInputMoney from '@/components/Base/Input/Money'

export default {
  name: 'FilterRate',
  components: {
    NoUiSlider,
    BaseInputMoney,
  },
  props: {
    data: { type: Object, required: true },
  },
  data() {
    return {
      activeTab: {},
      rangeValue: [],
      from: 0,
      to: 0,
      inputError: [],
    }
  },
  computed: {
    ...mapGetters('lobby', [
      'get_filterOptions',
    ]),
    filterFields() {
      if (!this.from && !this.to && !this.activeTab.value) {
        return {}
      }

      const [ , range ] = this.data.data
      const [ rates ] = this.data.data

      if (!rates || !range) return {}

      if (this.isCustomValue) {
        return {
          [range.minKey]: this.from * 100,
          [range.maxKey]: this.to * 100,
        }
      }
      return {
        [rates.key]: this.activeTab.value,
      }
    },
    presetRates() {
      const [ rates ] = this.data.data

      return rates?.data?.map(({ title, value, selected }) => {
        return {
          title,
          value,
          selected,
          id: value,
        }
      })
    },
    presetRange() {
      const [ , range ] = this.data.data

      return {
        max: range.maxValue / 100,
        min: range.minValue / 100,
      }
    },
    isCustomValue() {
      return !!this.activeTab.selected
    },
  },
  watch: {
    filterFields: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      },
    },
    rangeValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal[0] === oldVal[0] && newVal[1] === oldVal[1]) return

        this.updateFields()
      },
    },
  },
  mounted() {
    this.initFilters()
  },
  methods: {
    initFilters() {
      const { filterRate } = this.get_filterOptions.selected

      if (!Object.values((filterRate || {})).some(s => s)) {
        this.from = this.presetRange.min
        this.to = this.presetRange.max
        return
      }
      const [ , range ] = this.data.data
      const [ rates ] = this.data.data
      const isCustomField = filterRate[range.maxKey] || filterRate[range.minKey]
      let findingSelect = null

      if (isCustomField) {
        findingSelect = (el) => el.selected
        this.from = filterRate[range.minKey] / 100
        this.to = filterRate[range.maxKey] / 100
      }
      else {
        findingSelect = (el) => el.id === filterRate[rates.key]
      }

      const selectedTab = this.presetRates.find(findingSelect)

      this.activeTab = selectedTab
      this.$emit('input', this.filterFields)

    },
    updateFields() {
      const [ from, to ] = this.rangeValue
      this.from = from
      this.to = to
    },
    reset() {
      this.activeTab = {}
      this.from = 0
      this.to = 0
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
